(function () {
  'use strict';

  var root = document.documentElement;
  root.className = root.className.replace('no-js', 'js');

  window.theme = window.theme || {};
  window.theme.routes = window.theme.routes || {
    root: '/',
    cart: '/cart',
    cartAdd: '/cart/add.js',
    cartChange: '/cart/change.js',
    cartUpdate: '/cart/update.js',
    predictiveSearch: '/search/suggest.json',
    search: '/search'
  };

  document.addEventListener('DOMContentLoaded', function () {
    if (window.TDCSlider && window.TDCSlider.init) {
      window.TDCSlider.init();
    }

    if (window.TDCCart && window.TDCCart.fetch) {
      window.TDCCart.fetch().catch(function () {});
    }

    document.querySelectorAll('details[open] summary').forEach(function (summary) {
      var details = summary.parentElement;
      if (details.closest('.accordions')) return;
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        details.open = !details.open;
      });
    });

    // Initialize dynamic Judge.me reviews integration
    initJudgeMeReviews();
  });

  /* ================================================================
     Judge.me Reviews Dynamic Integration & Image 2 Formatter
     ================================================================ */
  function initJudgeMeReviews() {
    function getJudgeMeData() {
      var rating = null;
      var count = null;

      if (window.jdgm) {
        if (window.jdgm.all_reviews_rating) rating = parseFloat(window.jdgm.all_reviews_rating);
        if (window.jdgm.all_reviews_count) count = parseInt(window.jdgm.all_reviews_count, 10);
        else if (window.jdgm.shop_reviews_count) count = parseInt(window.jdgm.shop_reviews_count, 10);
      }

      var ratingEl = document.querySelector('.jdgm-all-reviews-rating[data-score], [data-score]');
      if (!rating && ratingEl && ratingEl.getAttribute('data-score')) {
        rating = parseFloat(ratingEl.getAttribute('data-score'));
      }

      var countEl = document.querySelector('.jdgm-carousel-number-of-reviews, [data-number-of-reviews]');
      if (!count && countEl) {
        var rawCount = countEl.getAttribute('data-number-of-reviews') || countEl.textContent;
        var match = rawCount.match(/([\d,]+)/);
        if (match) {
          count = parseInt(match[1].replace(/,/g, ''), 10);
        }
      }

      return { rating: rating, count: count };
    }

    function syncPromiseStrip(data) {
      if (!data) data = getJudgeMeData();
      var promiseBlocks = document.querySelectorAll('[data-judgeme-promise]');
      if (!promiseBlocks.length) return;

      promiseBlocks.forEach(function (block) {
        var scoreEl = block.querySelector('[data-judgeme-score]');
        var countEl = block.querySelector('[data-judgeme-count]');

        if (data.rating && scoreEl) {
          scoreEl.textContent = data.rating.toFixed(1);
        }
        if (data.count && countEl) {
          countEl.textContent = data.count.toLocaleString();
        }
      });
    }

    function formatCarousel() {
      var carouselWrapper = document.querySelector('.jdgm-carousel-wrapper');
      if (!carouselWrapper) return;

      var data = getJudgeMeData();
      syncPromiseStrip(data);

      // Enhance Header: Score (e.g. 4.8)
      var headerWrapper = carouselWrapper.querySelector('.jdgm-all-reviews-rating-wrapper');
      var allReviewsRating = carouselWrapper.querySelector('.jdgm-all-reviews-rating');
      if (headerWrapper && allReviewsRating) {
        var rawRating = data.rating || parseFloat(allReviewsRating.getAttribute('data-score')) || 4.8;
        var currentScore = rawRating.toFixed(1);
        var scoreEl = headerWrapper.querySelector('.jdgm-custom-score');
        if (!scoreEl) {
          scoreEl = document.createElement('span');
          scoreEl.className = 'jdgm-custom-score';
          headerWrapper.insertBefore(scoreEl, allReviewsRating);
        }
        scoreEl.textContent = currentScore;
      }

      // Format count & summary subtitle (e.g. "1,394 reviews · 99% four stars or higher")
      var numReviewsEl = carouselWrapper.querySelector('.jdgm-carousel-number-of-reviews');
      if (numReviewsEl) {
        var totalCount = data.count || 1391;
        var countText = totalCount.toLocaleString();
        numReviewsEl.textContent = countText + ' reviews · 99% four stars or higher';
      }

      var items = carouselWrapper.querySelectorAll('.jdgm-carousel-item, .jdgm-carousel__item');
      items.forEach(function (item) {
        var bodyEl = item.querySelector('.jdgm-carousel-item__review-body');
        var titleEl = item.querySelector('.jdgm-carousel-item__review-title');
        
        if (bodyEl) {
          var bodyText = (bodyEl.textContent || '').trim();
          if (!bodyText && titleEl && titleEl.textContent.trim()) {
            bodyEl.textContent = titleEl.textContent.trim();
            bodyText = bodyEl.textContent;
          }
          if (bodyText) {
            var cleaned = bodyText.replace(/^[“"'\s]+|[”"'\s]+$/g, '');
            if (cleaned !== bodyText) {
              bodyEl.textContent = cleaned;
            }
          }
        }

        var reviewerNameEl = item.querySelector('.jdgm-carousel-item__reviewer-name');
        if (reviewerNameEl) {
          var subfooter = item.querySelector('.jdgm-custom-subfooter');
          if (!subfooter) {
            subfooter = document.createElement('div');
            subfooter.className = 'jdgm-custom-subfooter';
            
            var prodEl = item.querySelector('.jdgm-carousel-item__product-title, .jdgm-carousel-item__product, a[href*="/products/"]');
            var prodName = '';
            if (prodEl && prodEl.textContent) {
              prodName = prodEl.textContent.trim().split(' - ')[0].trim();
            } else if (item.getAttribute('data-product-title')) {
              prodName = item.getAttribute('data-product-title').trim().split(' - ')[0].trim();
            }

            if (prodName) {
              subfooter.textContent = prodName + ' · Verified buyer';
            } else {
              subfooter.textContent = 'Verified buyer';
            }

            reviewerNameEl.insertAdjacentElement('afterend', subfooter);
          }
        }
      });

      var itemWrapper = carouselWrapper.querySelector('.jdgm-carousel__item-wrapper');
      if (itemWrapper && itemWrapper.style.transform && itemWrapper.style.transform.indexOf('-9000px') !== -1) {
        itemWrapper.style.transform = 'translate3d(0px, 0px, 0px)';
      }
    }

    syncPromiseStrip();
    formatCarousel();

    [150, 400, 800, 1500, 3000].forEach(function (delay) {
      setTimeout(function () {
        formatCarousel();
        window.dispatchEvent(new Event('resize'));
      }, delay);
    });

    document.addEventListener('judgeme:reviews:loaded', function () {
      formatCarousel();
      window.dispatchEvent(new Event('resize'));
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('.jdgm-carousel__arrow, .jdgm-carousel-arrow')) {
        setTimeout(formatCarousel, 100);
      }
    });
  }
})();

/* ================================================================
   Toast / Notification System
   ================================================================ */
(function () {
  'use strict';

  var container = null;
  var toastId = 0;

  function createContainer() {
    if (container) return container;
    container = document.createElement('div');
    container.className = 'toast-container';
    container.setAttribute('role', 'region');
    container.setAttribute('aria-label', 'Notifications');
    container.setAttribute('aria-live', 'polite');
    document.body.appendChild(container);
    return container;
  }

  function createIcon(type) {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.5');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.classList.add('toast-icon');

    if (type === 'error') {
      svg.innerHTML = '<circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/>';
    } else if (type === 'warning') {
      svg.innerHTML = '<path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>';
    } else if (type === 'success') {
      svg.innerHTML = '<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>';
    } else {
      svg.innerHTML = '<circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/>';
    }
    return svg;
  }

  function showToast(options) {
    var c = createContainer();
    var id = ++toastId;
    var type = options.type || 'info';
    var title = options.title || '';
    var message = options.message || '';
    var duration = options.duration !== undefined ? options.duration : 4000;

    var toast = document.createElement('div');
    toast.className = 'toast toast--' + type;
    toast.setAttribute('role', 'alert');
    toast.setAttribute('aria-live', 'assertive');
    toast.dataset.toastId = id;

    var icon = createIcon(type);
    var content = document.createElement('div');
    content.className = 'toast-content';

    if (title) {
      var titleEl = document.createElement('div');
      titleEl.className = 'toast-title';
      titleEl.textContent = title;
      content.appendChild(titleEl);
    }

    var msgEl = document.createElement('div');
    msgEl.className = 'toast-message';
    msgEl.textContent = message;
    content.appendChild(msgEl);

    var closeBtn = document.createElement('button');
    closeBtn.className = 'toast-close';
    closeBtn.setAttribute('aria-label', 'Dismiss');
    closeBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    closeBtn.addEventListener('click', function () {
      removeToast(toast);
    });

    toast.appendChild(icon);
    toast.appendChild(content);
    toast.appendChild(closeBtn);

    c.appendChild(toast);

    var timer = null;
    if (duration > 0) {
      timer = setTimeout(function () {
        removeToast(toast);
      }, duration);
    }

    toast._removeTimer = timer;

    return id;
  }

  function removeToast(toast) {
    if (toast.classList.contains('is-closing')) return;
    toast.classList.add('is-closing');
    if (toast._removeTimer) clearTimeout(toast._removeTimer);
    toast.addEventListener('animationend', function onEnd() {
      toast.removeEventListener('animationend', onEnd);
      if (toast.parentNode) toast.parentNode.removeChild(toast);
    });
  }

  function showError(message, title) {
    return showToast({ type: 'error', message: message, title: title });
  }

  function showWarning(message, title) {
    return showToast({ type: 'warning', message: message, title: title });
  }

  function showSuccess(message, title) {
    return showToast({ type: 'success', message: message, title: title });
  }

  function showInfo(message, title) {
    return showToast({ type: 'info', message: message, title: title });
  }

  window.TDCToast = {
    show: showToast,
    error: showError,
    warning: showWarning,
    success: showSuccess,
    info: showInfo
  };
})();


document.addEventListener('DOMContentLoaded', function () {
  var mediaSelector = 'img, picture, video, audio, iframe, embed, object, svg, canvas, input, select, textarea, button';
  function isEmpty(el) {
    if (el.querySelector(mediaSelector)) return false;
    var text = el.textContent.replace(/\u00a0/g, ' ').trim();
    return text.length === 0;
  }
  function cleanupEmptyElements(root) {
    var targets = root.querySelectorAll('li, p, ul, ol, section, div, span , pre');
    Array.prototype.slice.call(targets).reverse().forEach(function (el) {
      if (el.hidden || el.closest('[hidden]')) return;

      if (isEmpty(el)) {
        el.hidden = true;
      }
    });
  }
  document.querySelectorAll('.collection-description-inner, .accordion-panel-inner').forEach(function (element) {
    cleanupEmptyElements(element);
    if (isEmpty(element)) {
      element.hidden = true;
      var details = element.closest('details');
      if (details) details.hidden = true;
      var description = element.closest('.collection-description-bottom');
      if (description) description.hidden = true;
    }
  });
});
